<template>
  <card-wrapper :image="getImage(punchCard)" id="punch-card"
    :forced-height="106" :forced-width="284" :max-width="'284px'" :isHeightDisabled="!isFromHome">
    <template v-slot:textBody>
      <div class="header">
        {{ translatedName(punchCard) }}
      </div>

      <!-- <div class="subheader">
        {{ punchCard.rewardNameString }}
      </div> -->
      <div v-if="hasTargets" class="subheader valid-items-bullet">
        • Valid for select items
      </div>
      <div class="punch-progress" v-if="punchCard && punchCard.redeemCount">
        <div class="progress-text">
          {{ punchCard.earned || 0 }} / {{ punchCard.redeemCount }} stamps collected
        </div>
      <v-progress-linear
        :value="progressValue"
        style="margin-bottom: 2.5px !important; margin-top: 2.5px !important;"
        height="14"
        rounded
        class="progress-bar"
      />
      </div>
      <div class="expiration-description-bottom">
      <template v-if="punchCard.validTo">
        {{ $vuetify.t('$vuetify.common.expires') }}: {{ formatExpirationDate(punchCard.validTo) }}
      </template>
      <template v-else>
        {{ $vuetify.t('$vuetify.account.rewards.noExpiration') }}
      </template>
    </div>
    </template>

    <template v-slot:description>
      <!-- <v-layout v-if="!isDisabled && !history && !immutable && !isFromHome && !punchCard.using">
        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ allowedCards(punchCard) }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.account.rewards.free') }} {{ punchCard.unitPluralString }}
          </div>
        </v-flex>

        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ missingPoints(punchCard) }} / {{ punchCard.redeemCount }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.account.rewards.purchases') }}
          </div>
        </v-flex>
      </v-layout> -->
      
      <template v-if="isDisabled">
        {{ $vuetify.t('$vuetify.account.rewards.inPersonRedeemable') }}
      </template>
      <v-layout v-else-if="history">
        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ punchCard.qty }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.account.rewards.using') }}
          </div>
        </v-flex>

        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ Math.abs(punchCard.discountAmount) | currency }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.cart.discount') }}
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-else-if="immutable">
        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ punchCard.using || 0 }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.account.rewards.redeem') }}
          </div>
        </v-flex>

        <v-flex xs6 class="pointsContainer">
          <span class="points">
            {{ (allowedCards(punchCard) || 0) - (punchCard.using || 0) }}
          </span>

          <div>
            {{ $vuetify.t('$vuetify.account.rewards.remaining') }}
          </div>
        </v-flex>
      </v-layout>
      <div v-else>
        <v-layout v-if="!punchCard.using && !isFromHome && !information">
          <v-flex xs7 class="pointsContainer" style="margin: auto;">
            <v-btn @click="onChange(1, punchCard)" :disabled="allowedCards(punchCard) === 0 || notEnoughPoints" color="primary" block>
              {{ $vuetify.t('$vuetify.account.rewards.redeem') }}
             
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else-if="!isFromHome && !information" class="attribute-quantity-selector">
          <v-flex xs6 class="pointsContainer">
            <span class="points">
              <attribute-quantity-selector :maximum-selected="allowedCards(punchCard)"
                :init-quantity="punchCard.using || 0" :min-cardinality="allowedCards(punchCard)"
                :max-cardinality="allowedCards(punchCard)" @change="onChange($event, punchCard)" />

            </span>

            <div>
              {{ $vuetify.t('$vuetify.account.rewards.redeem') }}
            </div>
          </v-flex>

          <v-flex xs6 class="pointsContainer">
            <span class="points">
              {{ allowedCards(punchCard) }}
            </span>

            <div>
              {{ $vuetify.t('$vuetify.account.rewards.free') }} {{ punchCard.unitPluralString }}
            </div>
          </v-flex>
        </v-layout>
      </div>
    </template>
  </card-wrapper>
  <!-- </div> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';

import { matchTranslation } from "@/services/util.service"

import AttributeQuantitySelector from "../AttributeQuantitySelector"
import CardWrapper from "@/components/Wrappers/CardWrapper"

export default {
  components: {
    AttributeQuantitySelector,
    CardWrapper
  },

  props: {
    punchCard: {
      type: Object
      // required: true
    },
    promotion: {
      type: Object
    },

    //This change is based on the ticket DEV-4643
    isFromHome: {
      type: Boolean,
      default: false
    },
    history: {
      type: Boolean,
      default: false
    },
    immutable: {
      type: Boolean,
      default: false
    },
    information: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: String,
      default: '350px'
    }
  },

  computed: {
    progressValue() {
      const earned = this.punchCard.earned || 0
      const total = this.punchCard.redeemCount || 1
      const progress = Math.min((earned / total) * 100, 100)
      return progress
    },
    isDisabled() {
      return this.punchCard && !this.punchCard.onlineRedeemable && !this.history
    },
    notEnoughPoints() {
      return this.progressValue !== 100
    },
    hasTargets() {
      const punchCardHasTargets = this.punchCard && this.punchCard.targets && this.punchCard.targets.length > 0;
      const promotionHasTargets = this.promotion && this.promotion.targets && this.promotion.targets.length > 0;
      return punchCardHasTargets || promotionHasTargets;
    },
    currentStoreId() {
      return get(this.getStore, 'storeId', null)
    },

    ...mapGetters([
      'getStore',
      'getCustomerRewards',
      'getPunchCards',
      'getServerPunchCards',
      'getExistingOrder'
    ])
  },

  methods: {
    onChange(AmountSelected, punchCard) {
      this.$set(punchCard, 'storeId', this.currentStoreId)
      this.$set(punchCard, 'using', AmountSelected)

      this.fetchShoppingCart()
    },

    formatExpirationDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    allowedPoints(punchCard) {
      // For multi order situations, we need to subtract history subs points from their set amount
      let previousRewardsSum
      if (this.getExistingOrder && this.getExistingOrder.length) {
        previousRewardsSum = this.getExistingOrder.reduce((accumulator, order) => {
          if (order.punchCards.length)
            return (accumulator || 0) + order.punchCards.reduce((subSum, reward) => subSum + (reward.qty * punchCard.redeemCount), 0)
          return accumulator
        }, 0)
      } else {
        previousRewardsSum = 0
      }

      return punchCard.earned - previousRewardsSum
    },
    allowedCards(punchCard) {
      if (!this.allowedPoints(punchCard) || !punchCard.redeemCount)
        return 0
      return Math.floor(this.allowedPoints(punchCard) / punchCard.redeemCount)
    },
    missingPoints(punchCard) {
      if (!this.allowedPoints(punchCard))
        return 0
      if (!punchCard.redeemCount)
        return this.allowedPoints(punchCard)
      return this.allowedPoints(punchCard) % punchCard.redeemCount
    },

    translatedName(punchCard) {
      // Try to match the provided translation names to the current language
      // Fall back on the punchCards name if it couldn't be matched
      return matchTranslation(get(punchCard, 'nameTranslation.translations', [])) || punchCard.name
    },

    openConfig(punchCard) {
      this.setCouponItemDialog(JSON.parse(JSON.stringify(punchCard)))
    },

    showPunchCard(punchCard) {
      //Just to show punchcard on the home page. 
      //This change is based on the ticket DEV-4643
      if (this.isFromHome && this.$route.name == 'store')
        return true
      // Always show the used punch cards in history
      if (this.history)
        return true

      // immutable is used on the checkout page.
      // We only need to show punchCards that are actually being used here
      if (this.immutable && !punchCard.using)
        return false

      // Otherwise, in the cart, only show if there are usable cards
      // or always on the account page (information == true)
      return (this.allowedCards(punchCard) || this.information) && (!this.isDisabled || this.$route.name != 'store')
    },

    getImage(punchCard) {
      if (punchCard.imageURL)
        return `${process.env.VUE_APP_API_IMAGE}${punchCard.imageURL}`

      if ('REWARD' in this.getStore.images && this.getStore.images.REWARD[0] && this.getStore.images.REWARD[0].url)
        return `${process.env.VUE_APP_API_IMAGE}${this.getStore.images.REWARD[0].url}`

      return null
    },
    onImageError($error, punchCard) {
      console.error('Image Error', $error);

      punchCard.imageURL = null
    },

    ...mapActions(['fetchShoppingCart', 'fetchAccountDetails', 'setCouponItemDialog'])
  },

  mounted() {
    this.$root.$refs.punchCard = this;
  }
}
</script>

<style scoped>
.progress-bar{
  border-radius: 999px;
  overflow: hidden;
}
.progress-bar .v-progress-linear__bar {
  border-radius: 999px;
  background-color: var(--v-primary-base) !important;
}
.punch-progress {
  text-align: center;
}

.progress-text {
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: var(--v-primary-base) 
}


.PunchCards {
  position: relative;
  padding: 0px 10px;
}

.PunchCard {
  text-align: left;
  padding: 10px 10px 10px;
  /* margin: auto; */

  border-color: var(--v-primary-base) !important;
  border: solid;
  border-width: 2px 2px 2px 10px;
  border-radius: 5px;

  display: inline-block;

  width: 100%;
  min-width: 200px;
  max-width: 350px;

  height: 100%;

  white-space: normal;
}

.header {
  font-size: 12px;
  font-weight: 600;
  color: var(--v-primary-base);
}

.subheader {
  font-size: 10px;
  font-weight: 400;
  color: grey;
  margin-top: 0px;
}

.valid-items-bullet {
  font-weight: 600;
  color: grey;
  font-size: 11px;
}

.pointsContainer {
  text-align: center;
}

.points {
  font-size: 18px;
  color: var(--v-primary-base);
}

.pointsContainer>div {
  /* font-weight: 600; */
}

.attribute-quantity-selector {
  min-height: 90px;
  align-items: center;
}

.v-image {
  border-radius: 5px;
}

.expiration-description-bottom {
  left: 0;
  bottom: 0;
  color: #898a8d;
  margin: 0;
  text-align: left;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px !important;
}
</style>
